import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoSettings16 = t0 => {
  const $ = _c(11);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M5.70116 3.57973L4.50603 3.30393C4.28206 3.25224 4.04726 3.31958 3.88472 3.48212L3.48227 3.88457C3.31974 4.0471 3.2524 4.2819 3.30408 4.50588L3.57988 5.70101C3.64224 5.97121 3.53082 6.2518 3.30009 6.40562L2.13036 7.18541C1.9449 7.30908 1.8335 7.51721 1.8335 7.74014V8.25988C1.8335 8.48281 1.9449 8.69094 2.13036 8.81461L3.30009 9.59441C3.53082 9.74821 3.64224 10.0288 3.57988 10.299L3.30408 11.4941C3.2524 11.7181 3.31974 11.9529 3.48227 12.1155L3.88472 12.5179C4.04726 12.6804 4.28206 12.7478 4.50603 12.6961L5.70116 12.4203C5.97136 12.3579 6.25195 12.4693 6.40577 12.7001L7.18556 13.8698C7.30923 14.0553 7.51736 14.1667 7.7403 14.1667H8.26003C8.48296 14.1667 8.6911 14.0553 8.81476 13.8698L9.59456 12.7001C9.74836 12.4693 10.029 12.3579 10.2992 12.4203L11.4943 12.6961C11.7183 12.7478 11.9531 12.6804 12.1156 12.5179L12.518 12.1155C12.6806 11.9529 12.748 11.7181 12.6962 11.4941L12.4204 10.299C12.3581 10.0288 12.4695 9.74821 12.7002 9.59441L13.87 8.81461C14.0554 8.69094 14.1668 8.48281 14.1668 8.25988V7.74014C14.1668 7.51721 14.0554 7.30908 13.87 7.18541L12.7002 6.40562C12.4695 6.2518 12.3581 5.97121 12.4204 5.70101L12.6962 4.50588C12.748 4.2819 12.6806 4.0471 12.518 3.88457L12.1156 3.48212C11.9531 3.31958 11.7183 3.25224 11.4943 3.30393L10.2992 3.57973C10.029 3.64208 9.74836 3.53066 9.59456 3.29994L8.81476 2.13021C8.6911 1.94474 8.48296 1.83334 8.26003 1.83334H7.7403C7.51736 1.83334 7.30923 1.94474 7.18556 2.13021L6.40577 3.29994C6.25195 3.53066 5.97136 3.64208 5.70116 3.57973Z" />;
    t3 = <path d="M9.83317 7.99999C9.83317 9.01252 9.01237 9.83332 7.99984 9.83332C6.9873 9.83332 6.1665 9.01252 6.1665 7.99999C6.1665 6.98746 6.9873 6.16666 7.99984 6.16666C9.01237 6.16666 9.83317 6.98746 9.83317 7.99999Z" />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== iconColor) {
    t4 = <g stroke={iconColor} strokeWidth={1.5} strokeLinejoin="round">{t2}{t3}</g>;
    $[4] = iconColor;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <defs />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== ariaLabel || $[8] !== className || $[9] !== t4) {
    t6 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t4}{t5}</svg>;
    $[7] = ariaLabel;
    $[8] = className;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
export default IcoSettings16;